/* eslint-disable max-len */

import React from "react"
import BaseSvgIcon from "./Base"

const SharedUser = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 25 25">
      <g id="budicon-shared-user">
        <path d="M10.3207,13.9038a5,5,0,1,0-4.6414,0A7.0067,7.0067,0,0,0,1,20.5a.5.5,0,0,0,1,0,6,6,0,0,1,12,0,.5.5,0,0,0,1,0A7.0067,7.0067,0,0,0,10.3207,13.9038ZM4,9.5a4,4,0,1,1,4,4A4.0046,4.0046,0,0,1,4,9.5Zm16.64,1.8694a4,4,0,1,0-4.2751.0024,6.5261,6.5261,0,0,0-3.2438,2.4841,8.07,8.07,0,0,1,.7368.708A5.4946,5.4946,0,0,1,24,17.5a.5.5,0,0,0,1,0A6.5059,6.5059,0,0,0,20.64,11.3694ZM18.5,11a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,18.5,11Z" />
      </g>
    </BaseSvgIcon>
  )
}

export default SharedUser
